import { useMemo } from 'react';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';
import { useHome } from '../../hooks/useHome';
import { useLatestUpdates } from '../../hooks/useLatestUpdates';
import { LatestUpdateCard } from './LatestUpdateCard';
import { LatestUpdatesCarousel } from './LatestUpdatesCarousel';
import { LatestUpdatesSectionSkeleton } from './LatestUpdatesSectionSkeleton';

export const LatestUpdatesSection = () => {
  const { homePage } = useHome();
  const { updates, loading, error } = useLatestUpdates();

  const sectionTitle = useMemo(() => {
    return homePage.homePage?.latestUpdatesSection?.title || 'Latest updates';
  }, [homePage]);

  if (loading) {
    return (
      <Container className="py-sh-60">
        <SubContainer>
          <LatestUpdatesSectionSkeleton />
        </SubContainer>
      </Container>
    );
  }

  if (error || updates.length === 0) {
    return null;
  }

  return (
    <Container className="py-sh-60">
      <SubContainer>
        <AnimatedFadeInComponent fromBottom>
          <div>
            <h2 className="mb-sh-15 font-haffer text-sh-28-32 font-bold text-black-200">{sectionTitle}</h2>

            {updates.length > 3 ? (
              <LatestUpdatesCarousel updates={updates} />
            ) : (
              <div className="grid grid-cols-1 gap-4 overflow-visible md:grid-cols-2 lg:grid-cols-3">
                {updates.map((update) => (
                  <LatestUpdateCard key={update.documentId} update={update} />
                ))}
              </div>
            )}
          </div>
        </AnimatedFadeInComponent>
      </SubContainer>
    </Container>
  );
};
